import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-bootstrap/Spinner';
import axios from 'axios';
import qs from 'qs';

function DataSelect({
  name,
  onChange = null,
  onValueChange = null,
  onObjectChange = null,
  url,
  valueKey = 'id',
  titleKey = 'title',
  renderTitle,
  value,
  noneTitle,
  params = {},
}) {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [rawItems, setRawItems] = useState([]);
  const [currentValue, setValue] = useState(value);

  const getTitleByKey = (item) => item[titleKey];
  const getTitle = renderTitle ?? getTitleByKey;

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(url, {
        params,
        paramsSerializer: (paramData) => qs.stringify(paramData),
      });

      // Get the next nested data attribute if it looks paginated
      let { data } = response;
      if (data && typeof data === 'object' && 'data' in data) {
        data = data.data;
      }

      const newItems = data.map((thisItem) => ({
        value: thisItem[valueKey],
        title: getTitle(thisItem),
      }));

      setRawItems(data);

      setItems(newItems);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const valueChanged = (event) => {
    const newValue = event.target.value;
    setValue(newValue);

    if (typeof onChange === 'function') {
      onChange(event);
    }

    if (typeof onValueChange === 'function') {
      onValueChange(newValue);
    }

    if (typeof onObjectChange === 'function') {
      const newObject = rawItems.find((item) => {
        // If item[valueKey] is a number, cast newValue to a number
        if (typeof item[valueKey] === 'number') {
          return item[valueKey] === Number(newValue);
        }
        return item[valueKey] === newValue;
      });
      onObjectChange(newObject);
    }
  };

  useEffect(() => {
    loadData();
  }, [url, valueKey, titleKey]);

  let none;

  if (noneTitle) {
    none = <option value="">{noneTitle}</option>;
  }

  if (loading) {
    return <Spinner className="ml-2 mr-2" style={{ height: 18, width: 18, margin: 'auto' }} animation="border" role="status" variant="info" />;
  }

  return (
    <select className="form-control" name={name} onChange={valueChanged} value={currentValue}>
      {none}
      {items.map((item) => <option key={item.value} value={item.value}>{item.title}</option>)}
    </select>
  );
}

DataSelect.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  onObjectChange: PropTypes.func,
  url: PropTypes.string.isRequired,
  valueKey: PropTypes.string,
  titleKey: PropTypes.string,
  renderTitle: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noneTitle: PropTypes.string,
  params: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

DataSelect.defaultProps = {
  onChange: null,
  onValueChange: null,
  onObjectChange: null,
  valueKey: 'id',
  titleKey: 'title',
  renderTitle: null,
  value: undefined,
  noneTitle: undefined,
  params: {},
};

export default DataSelect;
